export default "__VITE_ASSET__Bj_ck99q__"